import React, { useState } from "react";
import { Form, Icon, Input, Button, Checkbox, notification } from "antd";
import {
  minLengthValidation,
  emailValidation,
} from "../../../utils/formValidation";
import { singUpApi } from "../../../api/user"; //function minuscula componente mayuscula

import "../RegisterForm/RegisterForm.scss";

export default function RegisterForm() {
  const [inputs, setInputs] = useState({
    //este hook guardara un objeto
    email: "", //valores reales del formulario
    password: "",
    repeatPassword: "",
    privacyPolicy: false,
  }); //estado default del formulario
  //dentro de value={input.email} se usa porque se le introducen variables, no textos

  //USO DE LAS FUNCIONES DE VALIDACION
  const [formValid, setFormValid] = useState({
    //el nombre de validacion deber ser igual al <input>
    email: false,
    password: false,
    repeatPassword: false,
    privacyPolicy: false,
  });

  const changeForm = (event) => {
    //aqui se guarda el formulario sus valores
    //funcion que detecta el event del formulario
    //este se declara en el formulario "onChange={changeForm}"
    if (event.target.name === "privacyPolicy") {
      setInputs({
        ...inputs, //obtiene todos los valores default ddeclarados
        [event.target.name]: event.target.checked, //y los cambiará
      });
    } else {
      setInputs({
        //entre parentesis luego llaves x k es objeto
        ...inputs,
        [event.target.name]: event.target.value,
      });
    }
  };

  const inputValidation = (event) => {
    const { type, name } = event.target; //se saca del <input type=mail name=mail> etc

    if (type === "email") {
      //=== es que debe ser igual exactamente
      setFormValid({
        //express operator
        ...formValid, //para traer los valores en false del useState
        [name]: emailValidation(event.target), //usa la funcion y manda el name
      });
    }
    if (type === "password") {
      setFormValid({
        ...formValid,
        [name]: minLengthValidation(event.target, 6),
      });
    }
    if (type === "checkbox") {
      setFormValid({
        //express operator
        ...formValid, //para traer los valores en false
        [name]: event.target.checked,
      });
    }
  };

  const register = async (event) => {
    //mostrar en consola si se está registrando
    event.preventDefault(); //para que no recargue formulario
    //para ejecutar se usa "onSubmit={register}(es una funcion)"

    //destructuring para sacar los valores guardaos en useState

    const emailVal = inputs.email;
    const passwordVal = inputs.password; //no se hace uso de destructuring porque seria igual que formValid
    const repeatPasswordVal = inputs.repeatPassword; //asi que solo se asignan a una nueva variable
    const privacyPolicyVal = inputs.privacyPolicy;

    if (!emailVal || !passwordVal || !repeatPasswordVal || !privacyPolicyVal) {
      notification["error"]({
        message: "Todos los campos son obligatorios.",
      });
    } else {
      if (passwordVal !== repeatPasswordVal) {
        notification["error"]({
          message: "Las contraseñas deben ser iguales.",
        });
      } else {
        const result = await singUpApi(inputs); //si el proceso es correcto useState en inputs guarda
        //los valores del formulario
        //la funcion en user.js  debe tener return el "fetch" para que se guarde en la constante
        //el resultado de la conexion si ya existe el usuario o cualquier otro4
        if (!result.ok) {
          notification["error"]({
            message: result.message,
          });
        } else {
          notification["success"]({
            message: result.message,
          });
          resetForm();
        }
      }
    }
  };

  const resetForm = () => {
    const inputs = document.getElementsByTagName("input");
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].classList.remove("success");
      inputs[i].classList.remove("error");
    }
    setInputs({
      email: "", //valores reales del formulario
      password: "",
      repeatPassword: "",
      privacyPolicy: false,
    });
    setFormValid({
      email: false,
      password: false,
      repeatPassword: false,
      privacyPolicy: false,
    });
  };

  return (
    <Form className="register-form" onSubmit={register} onChange={changeForm}>
      <Form.Item>
        <Input
          prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
          type="email"
          name="email"
          placeholder="Correo electrónico"
          className="register-form-input"
          onChange={inputValidation}
          value={inputs.email}
        />
      </Form.Item>
      <Form.Item>
        <Input
          prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
          type="password"
          name="password"
          placeholder="Contraseña"
          className="register-form-input"
          onChange={inputValidation}
          value={inputs.password}
        />
      </Form.Item>
      <Form.Item>
        <Input
          prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
          type="password"
          name="repeatPassword"
          placeholder="Repetir Contraseña"
          className="register-form-input"
          onChange={inputValidation}
          value={inputs.repeatPassword}
        />
      </Form.Item>
      <Form.Item>
        <Checkbox
          name="privacyPolicy"
          checked={inputs.privacyPolicy}
          onChange={inputValidation}
        >
          He leído y acepto la política de privacidad.
        </Checkbox>
      </Form.Item>
      <Form.Item>
        <Button htmlType="submit" className="register-form-button">
          Crear cuenta
        </Button>
      </Form.Item>
    </Form>
  );
}
